import type { GlossaryData, GlossaryTerm, GlossaryTopic } from "@/components/exercises/exercise.interfaces";

export const glossaryTopicContentClass = "px-1 pt-4 pb-4";
export const glossaryTopicHeadingClass =
  "mb-4 text-base font-semibold text-foreground text-balance";
export const glossaryTermGridClass =
  "grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] items-start gap-4 px-0.5";

export function migrateLegacyGlossaryData(data: unknown): GlossaryData {
  if (!data || typeof data !== "object") {
    return { title: "", topics: [] };
  }

  const record = data as Record<string, unknown>;

  if (Array.isArray(record.topics)) {
    return {
      title: typeof record.title === "string" ? record.title : "",
      topics: record.topics as GlossaryTopic[],
    };
  }

  if (Array.isArray(record.terms)) {
    const title = typeof record.title === "string" ? record.title : "";
    return {
      title,
      topics: [
        {
          id: "topic-migrated",
          title: title || "Geral",
          terms: record.terms as GlossaryTerm[],
          order: 0,
        },
      ],
    };
  }

  return {
    title: typeof record.title === "string" ? record.title : "",
    topics: [],
  };
}

export function sortTopics(topics: GlossaryTopic[]): GlossaryTopic[] {
  return [...topics].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export function sortTerms(terms: GlossaryTerm[]): GlossaryTerm[] {
  return [...terms].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export function matchesGlossarySearch(term: GlossaryTerm, query: string): boolean {
  const normalized = query.toLowerCase().trim();
  if (!normalized) return true;

  return (
    term.term.toLowerCase().includes(normalized) ||
    term.definition.toLowerCase().includes(normalized)
  );
}
